<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Status</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect className="tbl_select" :codes="saleStatusCodes" :showDesc="false" v-model="status_code" />
				</span>

				<em class="lt_text">Return Type</em>
				<span class="int_type_no_border mgr_10">
					<CodeSelect className="tbl_select" :codes="returnTypes" :width="70" :showDesc="false" v-model="return_type_code" />
				</span>

				<em class="lt_text">Return Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="so_date_from"/> ~ <CustomDatePicker v-model="so_date_to"/></span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="ship_to_code" ph="Ship To" :customerOnly="true" :showName="false" @set-partner="setPartner" />
				</span>
				<span class="int_type_no_border mgr_5">
					<PartnerSelect v-model="bill_to_code" ph="Bill To" :customerOnly="true" :showName="false" @set-partner="setPartner" />
				</span>

				<em class="lt_text">State</em>
				<span class="int_type_no_border mgr_10"> <CodeSelect :width="100" :codeWidth="120" :showDesc="false" :codes="states" v-model="state" /> </span>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>
			</div>
			<div class="left_option">
				<item-class-select-multi-s style="display:inline-block;" ref="ItemClassSelectMultiS" :multiSelect="true" v-model="itemClasses" />

				<span class="int_type sm_int">
					<input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>

				<span v-if="temp_invoices.length > 0"
					><a href="javascript:;" @click="openTempInvoices()"
						><font color="red">{{ temp_invoices.length }} Temp Sales Order(s)</font></a
					></span
				>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="1%"><input type="checkbox" @change="selectAll" /></th>
					<th width="8%">
						<a href="javascript:;" @click="sort('status')">Status{{ sortMark('status') }}</a>
					</th>
					<th width="6%">Inv. No</th>
					<th width="7%">S/O No</th>
					<th width="6%">
						<a href="javascript:;" @click="sort('so_date')">Return Date{{ sortMark('so_date') }}</a>
					</th>
					<th width="5%">
						<a href="javascript:;" @click="sort('ship_to_code')">Ship To{{ sortMark('ship_to_code') }}</a>
					</th>
					<th width="15%">
						<a href="javascript:;" @click="sort('ship_to_name')">Ship To Name{{ sortMark('ship_to_name') }}</a>
					</th>
					<th width="5%">
						<a href="javascript:;" @click="sort('bill_to_code')">Bill To{{ sortMark('bill_to_code') }}</a>
					</th>
					<th width="15%">Bill To Name</th>
					<th width="7%">
						<a href="javascript:;" @click="sort('sales_group_name')">Sales Group{{ sortMark('sales_group_name') }}</a>
					</th>
					<!-- <th width="5%">S/O Amt.</th> -->
					<th width="6%">
						<a href="javascript:;" @click="sort('crt_name')">S/O Entry{{ sortMark('crt_name') }}</a>
					</th>
					<!-- <th v-if="invoice_type == 'R'" width="4%">
						Total Amt.
					</th>
					<th width="4%">
						<span v-if="invoice_type == 'S'">Channel</span>
						<span v-if="invoice_type == 'R'">Inv. Amt.</span>
					</th> -->
					<th>
						<a href="javascript:;" @click="sort('remark')">Accounting{{ sortMark('remark') }}</a>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no">
					<td><input type="checkbox" v-model="invoice.selected" /></td>
					<td class="al_center">
						{{ invoice.status_code | saleStatusName }}
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="selectInvoice(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.invoice_dn }}</font></a
						>
					</td>
					<!-- <td class="al_center">{{ invoice.invoice_date }}</td> -->
					<td class="al_left">
						<a href="javascript:;" @click="selectSo(invoice)"
							><font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.so_dn }}</font></a
						>
					</td>
					<td class="al_center">{{ invoice.so_date }}</td>

					<td class="al_left">
						<a href="javascript:;" :title="invoice.ship_to_address1" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_code }}</a>
					</td>
					<td class="al_left truncate">
						<a href="javascript:;" :title="invoice.ship_to_address1" @click="gotoPartner(invoice.ship_to_code)">{{ invoice.ship_to_name }}</a>
					</td>
					<td class="al_left">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_code }}</a>
					</td>
					<td class="al_left truncate" :title="invoice.bill_to_name">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_name }}</a>
					</td>
					<td class="al_left">{{ invoice.sales_group_name }}</td>
					<!-- <td class="al_right">{{ invoice.total_amount | toCurrency }}</td> -->
					<td class="al_left truncate">{{ invoice.crt_name }}</td>
					<!-- <template v-if="invoice_type == 'S'">
						<td class="al_left">{{ invoice.source }}</td>
					</template>
					<template v-else-if="invoice_type == 'R'">
						<td class="al_right">{{ invoice.total_shipped_amount | toCurrency }}</td>
						<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
					</template>
					<template v-else>
						<td class="al_left"></td>
					</template> -->
					<td class="al_left">{{ invoice.remark }}</td>
				</tr>
				<!-- <tr>
					<td colspan="13" class="al_right"><font color="red">Total</font></td>

					<td class="al_right">
						<font color="red">{{ total_amount_sum | toCurrency }}</font>
					</td>
					<td></td>
					<td v-if="invoice_type == 'R'"></td>
					<td class="al_right">
						<span v-if="invoice_type == 'R'"
							><font color="red">{{ invoice_amount_sum | toCurrency }}</font></span
						>
					</td>
					<td></td>
				</tr> -->
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li class="mgr_15">
					<PageSizeSelect v-model="page_size" @input="search()" />
				</li>

				<!-- <li v-if="modifiable && user.so_return"> -->
				<li><a href="javascript: void(0);" class="gray_bt" @click="salesOrderPrint">Print</a></li>
				<li v-if="modifiable">
					<router-link class="gray_bt" :to="{ name: 'whReturnDetail', params: { mode: 'add' }, query: { backUri: this.uri } }">Add</router-link>
				</li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'TempInvoice'" :draggable="false">
			<template slot="title">Temp Sales Orders</template>
			<template slot="body">
				<div style="width:700px; height:400px;" v-on:keyup.esc="close()">
					<table class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th width="15%">Ship To</th>
								<th>Name</th>
								<th width="15%">Sales Group</th>
								<th width="15%">Creation Time</th>
								<th width="10%">Delete</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(ti, index) in temp_invoices" v-bind:key="ti.temp_invoice_no" @click="OpenTempSo(ti, $event)">
								<td class="al_left">{{ ti.ship_to_code }}</td>
								<td class="al_left truncate" :title="ti.ship_to_name">{{ ti.ship_to_name }}</td>
								<td class="al_left">{{ ti.sales_group_name }}</td>
								<td class="al_left">{{ ti.crt_dt | moment('MM-DD HH:mm:ss') }}</td>
								<td class="al_left"><input type="button" value="Delete" class="int_line_bt" name="del" @click.prevent="deleteTempSo(ti, index)" /></td>
							</tr>
						</tbody>
					</table>

					<div class="popup_bottom">
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { companyMrtUrl, getMrtFile, objectToUrlParam, PrintType, Report } from '@/api/util';
import { apiSoIndex, apiSelectInvoiceList, apiDeleteTempInvoice, apiInvoicePrintDataList, apiUpdateSalesOrderListPrint } from '@/api/sales/invoice.js';
import PageSizeSelect from '@/components/common/PageSizeSelect';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import { today, daysAgo } from '@/utils/date.js';
import Modal from '@/components/common/Modal';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			status_code: null,
			so_date_from: daysAgo(3),
			so_date_to: today(),
			sales_group_code: null,
			ship_to_code: null,
			bill_to_code: null,
			state: null,
			keyword: null,
			channel: null,
			return_type_code: null,
			auto_approved: false,
			itemClasses: [],

			sort_key: 'so_date',
			sort_direction: 'DESC',

			salesGroups: [],
			states: [],
			saleStatusCodes: [],
			returnTypes: [],

			invoices: [],
			temp_invoices: [],

			modalName: '',
			ship_or_bill: '',
			showModal: false,

			total_amount_sum: 0,
			invoice_amount_sum: 0,

			retail_order_count: 0,
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
		PageSizeSelect,
		Modal,
		ItemClassSelectMultiS,
	},
	methods: {
		OpenTempSo(ti, event) {
			if (event.target.name == 'del') return;
			//this.$router.push({ name: 'soDetail', params: { mode: 'add', temp_invoice_no: ti.temp_invoice_no }, query: { backUri: this.uri } });
			this.OpenTempSoConfirm(ti);
		},
		OpenTempSoConfirm(ti) {
			this.$router.push({ name: 'whReturnDetail', params: { mode: 'add', temp_invoice_no: ti.temp_invoice_no }, query: { backUri: this.uri } });
		},
		deleteTempSo(ti, index) {
			this.$alertify.confirm('Are you sure to delete?', () => {
				this.tempDeleteConfirm(ti, index);
			});
		},
		async tempDeleteConfirm(ti, index) {
			const { data } = await apiDeleteTempInvoice(ti);

			if (data.result) {
				this.$toast.success('Deleted successfully');
				this.temp_invoices.splice(index, 1);
				if (this.temp_invoices.length == 0) this.closeModal();
			} else {
				this.$toast.error('Failed');
			}
		},
		openTempInvoices() {
			if (this.temp_invoices.length == 1) {
				this.OpenTempSoConfirm(this.temp_invoices[0]);
			} else {
				this.modalName = 'TempInvoice';
				this.showModal = true;
			}
		},
		sortMark: function(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.selectInvoices();
			//console.log(sort_key);
		},
		selectAll() {
			this.invoices.forEach(el => (el.selected = event.target.checked));
		},
		async salesOrderPrint() {
			if (this.invoices.filter(i => i.selected).length === 0) {
				this.$toast.error('Nothing Selected.');
				return;
			}

			let invoiceNos = [];
			this.invoices.filter(i => i.selected).forEach(value => invoiceNos.push(value.invoice_no));

			const file = 'ReturnSales';

			let { data } = await apiInvoicePrintDataList(objectToUrlParam({ invoiceNos: invoiceNos }));
			if (data.result_code === 'success') {
				const original_so_list = [];
				let list = [];
				data.invoice.forEach(function(invoice) {
					list.push({ invoice: invoice });
					if (!invoice.so_print_dt) original_so_list.push(invoice.invoice_no);
				});

				if (original_so_list.length > 0) {
					// S/O Print 정보 Update
					const { status } = await apiUpdateSalesOrderListPrint(original_so_list);
					if (status !== 200) {
						this.$toast.error('Network Error');
						return;
					}
				}

				const reportTemplate = await getMrtFile(companyMrtUrl(file));
				const report = new Report(reportTemplate, list, file, PrintType.List);

				this.$store.commit('setReport', report);

				return true;
			} else {
				this.$toast.error(data.errorSoList + ' An error has occurred.');
				return false;
			}
		},
		selectInvoice(invoice) {
			this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		selectSo(invoice) {
			this.$router.push({ name: 'whReturnDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectInvoices(pageNo);
		},
		// setSalesGroup(code) {
		// 	if (code) this.sales_group_code = code.code;
		// 	else this.sales_group_code = null;
		// },
		setPartner(partner) {
			//console.log(partner.code, partner.name);
			if (this.ship_or_bill == 'ship') this.ship_to_code = partner.code;
			else if (this.ship_or_bill == 'bill') this.bill_to_code = partner.code;

			this.search();
		},
		selectPartner(ship_or_bill) {
			this.ship_or_bill = ship_or_bill;
			this.modalName = 'PartnerSelect';
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			//this.invoice_type = 'S';
			this.status_code = null;
			this.so_date_from = daysAgo(3);
			this.so_date_to = today();
			this.sales_group_code = null;
			this.ship_to_code = null;
			this.bill_to_code = null;
			this.state = null;
			this.keyword = null;
			this.auto_approved = false;
			this.itemClasses = [];

			//this.search();

			//this.selectInvoices();
			// this.dept_code = null;
		},
		async search() {
			await this.selectInvoices();
			if (this.invoices.length == 1 && this.keyword) this.$router.push({ name: 'whReturnDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: this.invoices[0].invoice_no } });
		},
		async selectInvoices(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
				normal_temp_type: 'all',

				invoice_type: 'R',
				status_code: this.status_code,
				so_date_from: this.so_date_from,
				so_date_to: this.so_date_to,
				sales_group_code: this.sales_group_code,
				ship_to_code: this.ship_to_code,
				bill_to_code: this.bill_to_code,
				state: this.state,
				keyword: this.keyword,
				return_type_code: this.return_type_code,
				item_classes: this.itemClasses,
			};

			const { data } = await apiSelectInvoiceList(param);

			if (Array.isArray(data.invoiceList)) data.invoiceList.forEach(el => (el.selected = false));
			this.invoices = data.invoiceList;
			this.list_count = data.invoicesSum.list_count; //data.list_count;
			// this.total_amount_sum = data.invoicesSum.total_amount_sum;
			// this.invoice_amount_sum = data.invoicesSum.invoice_amount_sum;

			this.temp_invoices = data.tempInvoiceList;
			// this.retail_order_count = data.retailOrderCount;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/sales/wh_return?page_no=' + this.page_no;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			if (this.status_code) uri += '&status_code=' + this.status_code;
			if (this.return_type_code) uri += '&return_type_code=' + this.return_type_code;
			if (this.so_date_from) uri += '&so_date_from=' + this.so_date_from;
			if (this.so_date_to) uri += '&so_date_to=' + this.so_date_to;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			if (this.ship_to_code) uri += '&ship_to_code=' + this.ship_to_code;
			if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			if (this.state) uri += '&state=' + this.state;

			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPartner(code) {
			//console.log(code);
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		async index() {
			const { data } = await apiSoIndex();

			this.salesGroups = data.salesGroupList;
			this.returnTypes = data.returnTypeList;
			this.states = data.stateList;
		},
		async init() {
			await this.index();
			this.saleStatusCodes = this.$saleStatusCodes;

			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.status_code) this.status_code = this.$route.query.status_code;
			if (this.$route.query.return_type_code) this.return_type_code = this.$route.query.return_type_code;
			if (this.$route.query.so_date_from) {
				if (this.$route.query.so_date_from === 'NON_SELECT') this.so_date_from = null;
				else this.so_date_from = this.$route.query.so_date_from;
			}
			//if (this.$route.query.so_date_from) this.so_date_from = this.$route.query.so_date_from;
			if (this.$route.query.so_date_to) {
				if (this.$route.query.so_date_to === 'NON_SELECT') this.so_date_to = null;
				else this.so_date_to = this.$route.query.so_date_to;
			}
			//if (this.$route.query.so_date_to) this.so_date_to = this.$route.query.so_date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.ship_to_code) this.ship_to_code = this.$route.query.ship_to_code;
			if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
			if (this.$route.query.state) this.state = this.$route.query.state;

			await this.selectInvoices(this.$route.query.page_no);
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 3);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_wh_return');
		this.$store.commit('setSubTitle', 'Sales -> Warehouse Return');

		//this.selectInvoices();
		this.init();

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();
		//makeTableResizable();
	},
};
</script>

<style></style>
